import { downloadCsv, toCsv } from "utils/csv";
import { formatDate } from "./summaryConstants";

const HEADERS = [
  "Case Officer",
  "Admission Case Officer",
  "Client Case Officer",
  "Client",
  "Admission Ref",
  "Email",
  "Phone",
  "University/College",
  "Course",
  "Intake",
  "Status",
  "Has Account",
  "Account Verification",
  "Agreed",
  "Cost",
  "Paid",
  "Due",
  "Commission",
  "Discount",
  "Bonus",
  "Profit/Loss",
  "Referral",
  "Created",
  "Last Activity",
  "Client Id",
  "Admission Id",
];

const toRow = (row) => [
  row.caseOfficer,
  row.admissionCaseOfficer,
  row.clientCaseOfficer,
  row.clientName,
  row.admissionRef,
  row.email,
  row.phone,
  row.universityName,
  row.courseName,
  row.intake,
  row.status,
  row.hasAdmissionAccount ? "Yes" : "No",
  row.accountVerificationStatus,
  row.agreedAmount,
  row.cost,
  row.paidAmount,
  row.dueAmount,
  row.commission,
  row.discount,
  row.bonus,
  row.profitLoss,
  row.referral,
  row.createdDate ? formatDate(row.createdDate) : "",
  row.lastActivityDate ? formatDate(row.lastActivityDate) : "",
  row.clientId,
  row.admissionId,
];

export const buildAdmissionsExportCsv = (rows = []) => toCsv([HEADERS, ...rows.map(toRow)]);

export const downloadAdmissionsExportCsv = (rows, filename = "all-admissions.csv") =>
  downloadCsv(buildAdmissionsExportCsv(rows), filename);
